import { render, staticRenderFns } from "./OfferBasicForm.vue?vue&type=template&id=70da5cf0&scoped=true"
import script from "./OfferBasicForm.vue?vue&type=script&lang=js"
export * from "./OfferBasicForm.vue?vue&type=script&lang=js"
import style0 from "./OfferBasicForm.vue?vue&type=style&index=0&id=70da5cf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70da5cf0",
  null
  
)

export default component.exports